import script from "./SmartPhoneOrder.vue?vue&type=script&setup=true&lang=ts"
export * from "./SmartPhoneOrder.vue?vue&type=script&setup=true&lang=ts"

import "./SmartPhoneOrder.vue?vue&type=style&index=0&id=4e03c1c0&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e03c1c0"]])

export default __exports__